import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';

export class AddressType extends BaseEntityModel {
  id?: number;
  addressId?: number;
  type?: string;

  constructor(model: Partial<AddressType> = {}) {
    super(model);

    this.id = model.id;
    this.addressId = model.addressId;
    this.type = model.type;
  }
}
